module.exports = __webpack_public_path__ + "static/recipe-collect-5-2fb7158fbf91eb8f41be4dca1ae1417a.jpeg";